<template>
  <CRow v-if="companyData" class="m-0">
    <CCol cols="12" lg="12" class="pt-0">
      <span class="d-block mb-2"><b>{{$t('admin.Email_test_mode_enabled')}}</b></span>        
      <b-switch class="m-0" v-model="companyEmailTestModeEnabled" size="is-small" @input="confirmModal = true;">
        <span>{{companyEmailTestModeEnabled ? $t('Yes') : $t('No')}}</span>
      </b-switch>
      
      <b-modal :can-cancel="['x']" :active.sync="confirmModal" :width="960" scroll="keep">
        <CCard class="mb-0">
          <CCardHeader class="pb-0">
            <span>{{companyEmailTestModeEnabled ? $t('admin.Enable_email_test_mode_for_company') : $t('admin.Disable_email_test_mode_for_company')}}</span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol cols="12" lg="12" class="pt-0 pb-0">
                <span>{{companyEmailTestModeEnabled ? $t('admin.Are_you_sure_to_enable_email_test_mode_for_company', { company_name : companyData.details.company_name}) : $t('admin.Are_you_sure_to_disable_email_test_mode_for_company', { company_name : companyData.details.company_name})}}</span>
              </CCol>
            </CRow>
          </CCardBody>
          <CCardFooter>
            <CButton color="primary" @click="confirmEmailTestModeStatusUpdate();"><i class="fas fa-check mr-1"/>{{companyEmailTestModeEnabled ? $t('admin.Enable_email_test_mode') : $t('admin.Disable_email_test_mode')}}</CButton>
            <CButton color="secondary" @click="cancelEmailTestModeStatusUpdate()"><i class="fas fa-times mr-1"/>{{ $t('Cancel') }}</CButton>
          </CCardFooter>
        </CCard>
      </b-modal>    
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoyaltyStoreLocked',
  props: ['companyData'],
  watch: {
    companyData: {
      handler() {
        if(this.companyData && this.companyData.email_test_mode_enabled) {
          this.companyEmailTestModeEnabled = this.companyData.email_test_mode_enabled;
        }
      },
      deep: true,
      immediate: true
    }
  },  
  data() {
    return {
      updateApiMessage: null,
      companyEmailTestModeEnabled: false, 
      confirmModal: false
    }
  },
  methods: {
    confirmEmailTestModeStatusUpdate() {
      // Set the updateApiPath and updateApiMessage values
      if(this.companyEmailTestModeEnabled) {
        this.updateApiMessage = this.$t('admin.Email_test_mode_disabled_for_company', { company_name : this.companyData.details.company_name});
      } else {
        this.updateApiMessage = this.$t('admin.Email_test_mode_enabled_for_company', { company_name : this.companyData.details.company_name});
      } 

      axios.put(process.env.VUE_APP_API_URL + '/v1/core/company/email/testmode/status')
      .then(res => {
        this.$buefy.toast.open({ message: this.updateApiMessage, type: 'is-success', duration: 2000 });
        // Close the modal
        this.confirmModal = false;        
      })
      .catch(err => {
        console.error(err); 
      });
    },
    cancelEmailTestModeStatusUpdate() {
      this.companyEmailTestModeEnabled = !this.companyEmailTestModeEnabled;
      // Close the modal
      this.confirmModal = false;
    }  
  }
}
</script>